const getSignedCookieTimestamp = (state) => state.signedCookie.cookieTimestamp;

export default getSignedCookieTimestamp;
